import React, { useCallback } from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import {
  TimeTrackerComponentData,
  TimeTrackerField,
} from '@shared/data/entity/fields/TimeTrackerField';
import { WorkflowTimeTrackerComponent } from '@shared/scenes/workflows/views/view-components/WorkflowTimeTrackerComponent';
import { useResponsiveFormContext } from '../ResponsiveFormContext';
import { EditFieldContainer } from './EditFieldContainer';

interface TimeTrackerEditFieldProps {
  component: MBAPI.WorkflowTemplate_components_TimeTrackerComponent;
  field: TimeTrackerField | null;
  updateField: (componentId: string, field: TimeTrackerField) => void;
  error?: string;
  style?: StyleProp<ViewStyle>;
}

export function TimeTrackerEditField({
  component,
  field,
  updateField,
  style,
}: TimeTrackerEditFieldProps) {
  const responsiveForms = useResponsiveFormContext();
  const handleDataChanged = useCallback(
    (id: string, entries: TimeTrackerComponentData) => {
      updateField(id, new TimeTrackerField(entries));
    },
    [updateField],
  );

  if (responsiveForms) {
    return (
      <EditFieldContainer component={component} style={style}>
        <WorkflowTimeTrackerComponent
          component={component}
          initialData={field?.timerEntries}
          onDataChanged={handleDataChanged}
          isReadOnly={component.readonly === true}
          paddingHorizontal={0}
          iconPad={2}
        />
      </EditFieldContainer>
    );
  } else {
    return (
      <WorkflowTimeTrackerComponent
        component={component}
        initialData={field?.timerEntries}
        onDataChanged={handleDataChanged}
        isReadOnly={component.readonly === true}
        paddingHorizontal={3}
        iconPad={2}
      />
    );
  }
}
